import React, {useState} from 'react';
import TextareaAutosize from "react-autosize-textarea";
import {Button, Col, Collapse, Container, Row} from 'reactstrap';
import assets from "../../../../../util/assets";
import ProfilePic from "../../../../ProfilePic";
import PropTypes from "prop-types";
import "./index.css";
import {get as _get} from "lodash";
import {getData, LOGIN} from "../../../../../util/storage";
import {isEmpty} from "../../../../../util/utility";

CommentInput.propTypes = {
    profile_pic: PropTypes.string.isRequired,
    user_type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    setText: PropTypes.func.isRequired,
    isFetching: PropTypes.bool.isRequired,
    actionText: PropTypes.string.isRequired,
    onActionClick: PropTypes.func.isRequired,
    hideBottomArea: PropTypes.func,
    placeholder:PropTypes.string
};

CommentInput.defaultProps = {
    profile_pic: assets.user_placeholder,
    placeholder:"Add a public comment",
    user_type: "user",
    text:'',
    setText: () => {
    },
    isFetching: false,
    actionText: 'COMMENT',
    onActionClick: () => {

    },
    hideBottomArea:()=>{

    }
}

function CommentInput(props) {

    const text = props.text;
    const [isOpen, setIsOpen] = useState(false);
    const [isLogin, setIsLogin] = useState(false);

    const onChangeText = (text) => {
        props.setText(text);
    }

    const onBlur = () => {
        if (text.trim().length === 0) {
            setIsOpen(false)
        }
    }

    const onFocus = () => {
        if (!isLogin) {
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    setIsLogin(true)
                    setIsOpen(true)
                } else {
                    props.showLogin()
                }
            });
        } else {
            setIsOpen(true)
        }
    }

    const hideBottomArea = () => {
        props.hideBottomArea && props.hideBottomArea();
        setIsOpen(false)
        console.log("isOpen",isOpen)
    }

    return (
        <div className="comment-input-container">
            <ProfilePic
                profile_pic={props.profile_pic}
                is_verified={0}
                user_type={props.user_type}
            />
            <Container className="no-margin no-padding">
                <TextareaAutosize
                    className="textarea"
                    onBlur={onBlur}
                    onFocus={onFocus}
                    placeholder={props.placeholder}
                    onChange={event => onChangeText(event.target.value)}
                    value={text}
                />
                <Collapse isOpen={isOpen}>
                    <Row className="display-flex-vertical-center no-margin button-container">
                        <Col md="6" className="no-padding"/>
                        <Col md="3" className="no-padding" style={{textAlign: 'right'}}>
                            <Button color="outline-secondary"
                                    style={{padding: 6}}
                                    onClick={() => {
                                        hideBottomArea(props)
                                    }}>
                                CANCEL
                            </Button>
                        </Col>
                        <Col md="3" className="no-padding" style={{textAlign: 'right'}}>
                            <Button color="primary"
                                    style={{padding: 6}}
                                    onClick={!props.isFetching && props.onActionClick}
                                    disabled={text.trim().length === 0}>
                                {
                                    props.isFetching
                                        ?
                                        <img
                                            src={assets.loading_white}
                                            alt={"Loading"}
                                            width={26}
                                            height={26}
                                        />
                                        :
                                        props.actionText
                                }

                            </Button>
                        </Col>
                    </Row>
                </Collapse>
            </Container>
        </div>
    );
}

export default CommentInput;